import { render, staticRenderFns } from "./newZoneInfo.vue?vue&type=template&id=1abfd706"
import script from "./newZoneInfo.vue?vue&type=script&lang=js"
export * from "./newZoneInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports